// extracted by mini-css-extract-plugin
export default {"wrapper":"SettingsUpdatePassword_wrapper__5abfg","title":"SettingsUpdatePassword_title__L7niL","container":"SettingsUpdatePassword_container__9lf5w"};